(function (Drupal, $) {
  Drupal.behaviors.boxLine = {
    attach: function (context) {
      "use strict";

      $(once("select-processed", "select.select-box-line", context))
        .change(function (e) {
          var $this = $(this);
          var new_tab = $this[0].options[$this[0].selectedIndex].dataset.newTab;
          if (new_tab === "1") {
            $("<a />", { href: $this[0].value, target: "_blank" })
              .get(0)
              .click();
          } else {
            location = $this[0].value;
          }
        });
    },
  };
})(Drupal, jQuery);
